import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { apiClient } from "@/services/api-client";
import { SMS_ENDPOINTS } from "./sms-endpoints";
var PAGE_SIZE = 20;

/** Fetches a patient's SMS history (newest first); normalises the list envelope. */
export function fetchPatientMessages(_x) {
  return _fetchPatientMessages.apply(this, arguments);
}

/** Lists SMS templates for a workspace; sendability is filtered client-side. */
function _fetchPatientMessages() {
  _fetchPatientMessages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(patientId) {
    var _data$results;
    var _yield$apiClient$get, data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return apiClient.get(SMS_ENDPOINTS.patientMessages(patientId), {
            params: {
              limit: PAGE_SIZE,
              offset: 0
            }
          });
        case 1:
          _yield$apiClient$get = _context.v;
          data = _yield$apiClient$get.data;
          return _context.a(2, Array.isArray(data) ? data : (_data$results = data === null || data === void 0 ? void 0 : data.results) !== null && _data$results !== void 0 ? _data$results : []);
      }
    }, _callee);
  }));
  return _fetchPatientMessages.apply(this, arguments);
}
export function fetchSmsTemplates(_x2) {
  return _fetchSmsTemplates.apply(this, arguments);
}

/** Creates a new SMS template (workspace_id required in the payload). */
function _fetchSmsTemplates() {
  _fetchSmsTemplates = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(workspaceId) {
    var _yield$apiClient$get2, data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return apiClient.get(SMS_ENDPOINTS.templates, {
            params: {
              workspace_id: workspaceId
            }
          });
        case 1:
          _yield$apiClient$get2 = _context2.v;
          data = _yield$apiClient$get2.data;
          return _context2.a(2, Array.isArray(data) ? data : []);
      }
    }, _callee2);
  }));
  return _fetchSmsTemplates.apply(this, arguments);
}
export function createSmsTemplate(_x3) {
  return _createSmsTemplate.apply(this, arguments);
}

/** Partially updates an existing SMS template. */
function _createSmsTemplate() {
  _createSmsTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(payload) {
    var _yield$apiClient$post, data;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return apiClient.post(SMS_ENDPOINTS.templates, payload);
        case 1:
          _yield$apiClient$post = _context3.v;
          data = _yield$apiClient$post.data;
          return _context3.a(2, data);
      }
    }, _callee3);
  }));
  return _createSmsTemplate.apply(this, arguments);
}
export function updateSmsTemplate(_x4, _x5) {
  return _updateSmsTemplate.apply(this, arguments);
}

/** Returns whether the patient has opted out of SMS. */
function _updateSmsTemplate() {
  _updateSmsTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(templateId, payload) {
    var _yield$apiClient$patc, data;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return apiClient.patch(SMS_ENDPOINTS.template(templateId), payload);
        case 1:
          _yield$apiClient$patc = _context4.v;
          data = _yield$apiClient$patc.data;
          return _context4.a(2, data);
      }
    }, _callee4);
  }));
  return _updateSmsTemplate.apply(this, arguments);
}
export function fetchOptOutStatus(_x6) {
  return _fetchOptOutStatus.apply(this, arguments);
}

/** Enqueues an SMS for a patient; the API validates and returns 202. */
function _fetchOptOutStatus() {
  _fetchOptOutStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(patientId) {
    var _yield$apiClient$get3, data;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.n = 1;
          return apiClient.get(SMS_ENDPOINTS.optOutStatus(patientId));
        case 1:
          _yield$apiClient$get3 = _context5.v;
          data = _yield$apiClient$get3.data;
          return _context5.a(2, Boolean(data === null || data === void 0 ? void 0 : data.opted_out));
      }
    }, _callee5);
  }));
  return _fetchOptOutStatus.apply(this, arguments);
}
export function sendSms(_x7) {
  return _sendSms.apply(this, arguments);
}

/** Re-enqueues a failed message; the server re-checks opt-out and template state. */
function _sendSms() {
  _sendSms = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(payload) {
    var _yield$apiClient$post2, data;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          _context6.n = 1;
          return apiClient.post(SMS_ENDPOINTS.messages, payload);
        case 1:
          _yield$apiClient$post2 = _context6.v;
          data = _yield$apiClient$post2.data;
          return _context6.a(2, data);
      }
    }, _callee6);
  }));
  return _sendSms.apply(this, arguments);
}
export function retrySms(_x8) {
  return _retrySms.apply(this, arguments);
}
function _retrySms() {
  _retrySms = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(messageId) {
    var _yield$apiClient$post3, data;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          _context7.n = 1;
          return apiClient.post(SMS_ENDPOINTS.retry(messageId));
        case 1:
          _yield$apiClient$post3 = _context7.v;
          data = _yield$apiClient$post3.data;
          return _context7.a(2, data);
      }
    }, _callee7);
  }));
  return _retrySms.apply(this, arguments);
}